"use client";

import { useState } from "react";
import { toast } from "react-hot-toast";
import Modal from "../../../components/shared-modules/Modal";
import styles from "../../../styles/statusModal.module.css";
import { createStatus } from "../../../services/admin/statuses";
import { handleApiError } from "../../../utils/handleApiError";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import Button from "../../../components/button-v1";
import { useQueryClient } from "@tanstack/react-query";

const AddStatusModal = ({ isOpen, onClose, comp_renderer, current_render }) => {
  const queryClient = useQueryClient();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await createStatus({
        name,
        description,
      });
      // comp_renderer(!current_render);
      toast.success("Status added successfully");
      queryClient.invalidateQueries(["admin-statuses"]);

      onClose();
      setLoading(false);
      setName("");
      setDescription("");
    } catch (error) {
      handleApiError(error);
      setLoading(false);
    }
  };

  const modalFooter = (
    <div className={styles.modal_footer}>
      <button
        type="button"
        className={styles.cancel_btn}
        onClick={onClose}
        disabled={loading}
      >
        Cancel
      </button>
      <button
        type="submit"
        form="addStatusForm"
        className={styles.submit_btn}
        disabled={loading || !name.trim()}
      >
        {loading ? "Adding..." : "Add Status"}
      </button>
    </div>
  );

  return (
    <Dialog open={isOpen} setOpen={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Status</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <form
            id="addStatusForm"
            onSubmit={handleSubmit}
            className={styles.form}
          >
            <div className={styles.form_group}>
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className={styles.input}
                placeholder="Enter status name"
              />
            </div>
            <div className={styles.form_group}>
              <label htmlFor="description">Description (Optional)</label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className={styles.textarea}
                rows={4}
                placeholder="Enter status description (optional)"
              />
            </div>
          </form>
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} loading={loading}>
            Add
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddStatusModal;
